export default "__VITE_ASSET__MyYe6_ys__"